// SurveyConnectivityContactDescription.tsx
import React, { FunctionComponent } from 'react';
import { Collapse, Col, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';

const { Panel } = Collapse;
const { Text, Paragraph } = Typography;

interface ISurveyConnectivityContactDescriptionProps {
    groupId?: string;
}

const SurveyConnectivityContactDescription: FunctionComponent<ISurveyConnectivityContactDescriptionProps> = ({ groupId }) => {
    const intl = useIntl();

    return (
        <Collapse style={{ marginBottom: '10px' }}>
            <Panel
                key="1"
                header={intl.formatMessage({
                    id: 'Show-Description',
                    defaultMessage: 'Show Description',
                })}
            >
                <Row>
                    <Col>
                        <Text type="secondary">GroupId: {groupId}</Text>
                    </Col>
                </Row>
                <Row gutter={[24, 10]}>
                    <Col>
                        <Paragraph>
                            {intl.formatMessage({
                                id: 'survey-connectivityInfo-technicalContactDetails-description',
                                defaultMessage:
                                    'Provide Technical Contact Person Details. This is the person who is contacted to support and complete the eInvoice connection connectivity setup.',
                            })}
                        </Paragraph>
                        <Paragraph strong={true}>
                            {intl.formatMessage({
                                id: 'survey-connectivityInfo-technicalContactDetails-note',
                                defaultMessage:
                                    'NB: Completion of the connectivity set up information will be done with our service provider after the survey completion, kindly fill in the minimum connectivity information.',
                            })}
                        </Paragraph>
                    </Col>
                </Row>
            </Panel>
        </Collapse>
    );
};

export default SurveyConnectivityContactDescription;
